export const containsVariable = value => {
  if (typeof value !== 'string') return false;
  const variableRegex = /%\{([^}]+)\}/g;
  const matches = value.match(variableRegex);
  return !!matches;
};
